// src/pages/Settings.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CompanySettingsForm from "../components/settings/CompanySettingsForm";
import { hasPermission } from "../utils/permissions"; // your helper from Sidebar

export default function Settings() {
  const navigate = useNavigate();

  // useEffect(() => {
  //   // Redirect if no permission
  //   if (!hasPermission("company_settings", "view")) {
  //     navigate("/dashboard");
  //   }
  // }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        {/* <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Company Settings
          </h1>
          <p className="mt-2 text-gray-600 dark:text-gray-400">
            Manage your company profile, branding, compliance, and financial defaults.
          </p>
        </div> */}

        {/* Main Form */}
        {/* <CompanySettingsForm /> */}
        <div className="mb-10">
      <h1 className="text-3xl font-bold text-orange-500">Company Settings</h1>
      {/* <p className="mt-3 text-lg text-gray-400">
        Manage profile, branding, compliance, and financial defaults.
      </p> */}
    </div>

   
      <CompanySettingsForm />

      </div>
    </div>
  );
}